module.exports = __webpack_public_path__ + "assets/img/森林守护者.40364f11.png";